import {$api} from "../../../../services/request.config";
import {createSignRequestAction} from "../createSignRequest.action";
import countly from "../../../../../analytics/countly";
import { EVENT_NAMES } from "../../../../../analytics/events";

export const createSignRequestThunkAction = ({uid, setModalSentStatus}) => async (dispatch) => {
    try {
        const response = await $api.post(`v2/request/${uid}/create-sign-request`);
        if(response.data) {
            countly.event(EVENT_NAMES.LAYOFF_REQUEST_CREATED, { pid: localStorage.getItem("pid") });
            dispatch(createSignRequestAction(response.data));
            setModalSentStatus(true);
        }
    } catch (e) {
        // console.log('ERROR_WHILE_CREATE_SIGN_REQUEST: ', e?.response)
    }
};
